

















import breakpoints from 'library/assets/vars/breakpoints'
export default

	props: block: Object

	data: ->
		config:
			slidesPerPage: 3
			showDots: true
			showArrows: true
			gutter: 'var(--card-gutter)'
			peekLeft: 'var(--gutter)'
			peekRight: 'var(--peek-right)'
			responsive: [
				{
					maxWidth: parseInt breakpoints['tablet-landscape']
					slidesPerPage: 2
				}
				{
					maxWidth: parseInt breakpoints['mobile-landscape']
					slidesPerPage: 1
				}
			]

	computed:
		cards: -> @block.cards || []

